import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '分类导航',
    links: [
      { label: '性感穿搭技巧', href: '/category/xinggan-chuanda' },
      { label: '气质提升方法', href: '/category/qizhi-tisheng' },
      { label: '性感妆容教程', href: '/category/xinggan-zhuangrong' },
      { label: '自信女性风格', href: '/category/zixin-fengge' },
      { label: '时尚性感造型', href: '/category/shishang-zaoxing' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌介绍', href: '/about' },
      { label: '联系我们', href: '/about#contact' },
      { label: '用户口碑', href: '/about#testimonials' },
    ],
  },
  {
    title: '热门文章',
    links: [
      { label: '小黑裙的100种穿法', href: '/article/xiaoheijia-chuanda' },
      { label: '7天气质蜕变计划', href: '/article/zixin-congneidaowai' },
      { label: '红唇的秘密', href: '/article/hongchun-xuanze' },
      { label: '展现完美曲线指南', href: '/article/shencai-quxian' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <span className="text-2xl font-heading font-bold text-foreground-900 tracking-wide">
                魅力养成
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              专注女性魅力养成的时尚生活方式平台。从穿搭、妆容到气质培养，全方位帮助每位女性成为更好的自己。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors" aria-label="微信">
                <i className="ri-wechat-line text-lg" />
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-lg" />
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors" aria-label="小红书">
                <i className="ri-red-packet-line text-lg" />
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors" aria-label="抖音">
                <i className="ri-tiktok-line text-lg" />
              </a>
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-heading font-semibold text-foreground-900 mb-4">
                {group.title}
              </h4>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.href}>
                    <Link
                      to={link.href}
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 md:mt-12 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 美女性感魅力养成指南. 保留所有权利.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap">服务条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}